<div class="buttonFloatingDs__cont buttonFloatingDs__cont--{{size}}" (click)="clickEvent.emit()">
  <div class="buttonFloatingDs__cont__flex buttonFloatingDs__cont__flex--{{size}}">
    <ng-container *ngIf="icon">
      <app-ds-icon
        class="buttonFloatingDs__cont__flex__icon"
        [icon]="icon"
        [size]="iconSize"
        [color]="iconFillColorPrimary">
      </app-ds-icon>
    </ng-container>
    <ng-container *ngIf="label">
      <app-ds-typography
        class="buttonFloatingDs__cont__flex__label"
        [size]="typographySizeXXS"
        [fontFamily]="typographySemiBold"
        [text]="label"
        [color]="typographyColorPrimary">
      </app-ds-typography>
    </ng-container>
    <ng-container *ngIf="notificationsAreEnabled">
      <app-ds-notification
        class="buttonFloatingDs__cont__flex__notification"
        [size]="notificationSize"
        [notifications]="notifications">
      </app-ds-notification>
    </ng-container>
  </div>
</div>